/**
 * Created by satuk on 21.07.17.
 */
export const ADD_BASKET_ITEM = 'addBasketItem';
export const REMOVE_BASKET_ITEM = 'removeBasketItem';
export const REMOVE_BASKET = 'removeBasket';



// WEBPACK FOOTER //
// ./src/store/constants.js